export default __webpack_public_path__ + "static/media/blog2.31ebce0d.png";